import React, { useState, useEffect, useRef } from 'react';
import PubSub, { pubCall, pubSub } from './utils/PubSub';
import { Button, DotLoading, ErrorBlock, Modal, NumberKeyboard, Space, SpinLoading, Swiper, Toast } from 'antd-mobile';
import Reconciliation from './screens/Reconciliation';
import Authentication from './screens/Authentication';
import './App.css';
import { drawError } from './utils/utils';
import Reconnect from './components/Reconnect';
import LiveToggle from './components/LiveToggle';
import Cookies from "js-cookie";
import ListItem from './components/ListItem';
import Keyboard from './components/Keyboard';
import Ping from './components/Ping';

function App() {

  const ref = useRef();

  window.subscribed = [];

  // Set sitewide settings
  const [globals, setGlobals] = useState({
    station: false,
    is_logged_in: false,
    status: "authenticating",
    mode: "dark",
    connect: false,
  })

  // Set Light / Dark mode
  useEffect(() => {


    if (!Cookies.get("bm_sounds")) {
      // set default sounds settings 
      Cookies.set("bm_sounds", JSON.stringify({
        scanned: false,
        short: false,
        over: false,
        even: false,
        error: true,
        months: 0
      }), { expires: 365 })

    }


    window.can_call = false;
    document.documentElement.setAttribute('data-prefers-color-scheme', globals.mode)
  }, [globals.mode])

  const setWorkStation = (_code, _store) => {


    if (!_code && _code !== 0) {
      return;
    }

    pubCall("work_station.set", { station: parseInt(_code) }, (_status, _result) => {

     
      if (_status) {

        // getSession

        pubCall("session.get", {}, (_stat, _res) => {
          if(_stat){
            window.minimum_rank = _res.minimum_rank; 
          }
        })

        ref.current?.swipeNext();
        setGlobals({ ...globals, "station": _result.result, "status": "ready", ready: false })

        Cookies.set("workstation", _code + "-" + _store, { expires: 14 });

        pubSub("work_station", {}, (_e, _f = {}) => {

          if (_f?.message?.data?.station === _result.result) {
            if (window.can_call) {
              window.can_call = false;
              const model = Modal.show({
                title: "Disconnected",
                content: <Reconnect onReconnect={() => {
                  model.close();
                  window.can_call = true;

                  setWorkStation(window.credentials.station, window.credentials.store_id);

                }} onHome={() => {

                  Cookies.set("workstation", null, { expires: 14 })
                  window.location.reload();
                }} />,
                closeOnMaskClick: false,
              })
            }
          }
        })

      } else {
        Toast.show({ content: <div style={{ "textAlign": "center" }}><big>There was an error</big><div className="shim" /><span style={{ "opacity": "0.5" }}>{_result.error}</span></div> })
      }
    })
  }

  // Connection Error
  const connectionError = () => {
    return (
      <div className="center-container">
        <div>
          <ErrorBlock title="Connection Error" description={<><DotLoading /></>} status='default' />
        </div>
      </div>
    )
  }

  // Loading
  const drawLoading = () => {
    return (
      <div className="center-container">
        <div style={{ "textAlign": "center" }}>
          <SpinLoading color='primary' style={{ '--size': '48px', "margin": "0 auto" }} />
        </div>
      </div>
    )
  }

  // Draw App UI 
  const drawRecon = () => {
    return (
      <Swiper indicator={() => <></>} allowTouchMove={false} ref={ref}>
        <Swiper.Item key={"station"}>
          <Authentication globals={globals} setGlobals={setGlobals} setWorkStation={setWorkStation} />
        </Swiper.Item>
        <Swiper.Item key={"reconciliation"}>
          {(globals.status === "ready" && <Reconciliation globals={globals} />)}
        </Swiper.Item>
      </Swiper>
    )
  }

  const draw = () => {
    // Draw Error
    if (globals.status === "error") return connectionError();
    // Draw Loading
    if (globals.status === "loading") return drawLoading();
    // Draw Ready
    if (globals.status === "authenticating" || globals.status === "ready") return drawRecon();
  }




  return (
    <div style={{ "height": window.innerHeight + "px", "overflow": "hidden" }} className="app">
      <PubSub globals={globals} setGlobals={setGlobals} />
      <Ping />
      {draw()}
      <LiveToggle />
    </div>
  );
}

export default App;
